// extracted by mini-css-extract-plugin
export default {"Button":"ActionPanel_Button__jZJp2","Panel":"ActionPanel_Panel__dwJO-"};